module.exports = __webpack_public_path__ + "img/message.2767b37f.svg";